module.exports = __webpack_public_path__ + "152eeec71e3254928900daa42505cea0.jpg";